<template lang="html">
  <div class="profile-my-sales-mobile-wrapper">
    <div class="actions-wrapper">
      <div class="search-wrapper">
        <InputView
          @keyup="(page = 1), getMySales()"
          v-model="search"
          type="text"
          :label="$t('nav.search')"
          icon="mdi:search"
        />
      </div>
      <div class="btn-dropdown-wrapper">
        <div @click="navigateToNewAd()" class="btn dark-blue">
          <img src="@/assets/icons/plusWhite.png" alt="trash icon" />
          {{ $t("profile.purchase.newSale") }}
        </div>
        <dropdown
          :defaultText="$t('dropdown.sort')"
          :selected="sortSelected"
          :list="sortList"
          :removable="true"
          @remove="(sortSelected = null), getMySales()"
          @changeOption="(sortSelected = $event), getMySales()"
        />
      </div>
    </div>
    <table v-if="purchases.length > 0">
      <tbody>
        <template v-for="purchase in purchases">
          <tr
            :class="{ deleted: purchase.archived === 1 }"
            :key="purchase.pro_id"
            @click="purchase.open = !purchase.open"
          >
            <td>
              <span
                @click="navigateToAd(purchase.pro_id, $event)"
                class="underline bold-td-text"
                >{{ purchase.pro_name }}</span
              >
            </td>
            <td class="light-grey">
              <div
                class="icon-wrapper"
                v-if="purchase.can_hide"
                @click="archive(purchase, $event)"
              >
                <img src="@/assets/icons/closeRed.png" alt="close icon" />
              </div>
              <span class="date-span">
                {{ purchase.pro_post_date.substring(0, 10) }}
              </span>
            </td>
          </tr>
          <tr
            class="dropdown-row"
            :key="purchase.pro_id + 'd'"
            :class="{ active: purchase.open, deleted: purchase.archived === 1 }"
            v-if="purchase.open"
          >
            <td colspan="100%" class="dropdown-td">
              <div class="dropdown">
                <my-sales-buyers
                  :rejectable="purchase.pro_reject === 1"
                  v-if="purchase.open"
                  :modalData="purchase"
                />
              </div>
            </td>
          </tr>
          <tr
            class="dropdown-row"
            :key="purchase.pro_id + 'm'"
            :class="{ active: purchase.open, deleted: purchase.archived === 1 }"
          >
            <!-- <td>
              <div class="dropdown">
                <my-sales-buyers :rejectable="purchase.pro_reject === 1" v-if="purchase.open" :modalData="purchase"/>
              </div>
            </td> -->
            <td class="regular-td-text">
              {{ purchase.off_quantity }} komada
              <span class="light-grey"
                >( {{ purchase.current_price }} {{ purchase.cur_id }} )</span
              >
            </td>
            <td class="light-grey">
              <span
                v-if="purchase.renewable"
                @click="renew(purchase, $event)"
                class="light-grey"
              >
                <img
                  :title="$t('main.renew')"
                  src="@/assets/icons/repeat.png"
                  alt="close icon"
                />
              </span>
              <!-- span v-else></span -->
              <span
                class="light-grey"
                v-if="purchase.editable === 1 && purchase.archived !== 1"
                @click="edit(purchase, $event)"
              >
                <img src="@/assets/icons/pen.png" alt="trash icon" />
              </span>
              <!-- span v-else></span -->
              <span
                class="light-grey"
                v-if="purchase.deletable === 1 && purchase.archived !== 1"
                @click="openDeleteConfirmation(purchase, $event)"
              >
                <img src="@/assets/icons/trash.png" alt="trash icon" />
              </span>
              <!-- span v-else></span -->
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <div class="empty" v-else>
      {{ $t("main.noSales") }}
    </div>
    <div v-if="purchases.length > 0" class="pagination-wrapper">
      <paginate
        v-model="page"
        :page-count="pageCount"
        :prev-text="getPaginationImages('Left')"
        :next-text="getPaginationImages('Right')"
        :container-class="'pagination'"
        :page-class="'page'"
        :click-handler="changePage"
      >
      </paginate>
    </div>
  </div>
</template>

<script>
import mySalesBuyers from "@/components/profile/mySalesBuyers.vue";
import eventBus from "@/shared/eventBus.js";
import Dropdown from "@/components/dropdown.vue";
import { api } from "@/api";
import TestInput from "../shared/testInput.vue";
export default {
  name: "profileMySalesMobile",
  components: {
    mySalesBuyers,
    InputView: TestInput,
    Dropdown
  },
  props: ["_sortSelected", "_search", "_page"],
  data() {
    return {
      purchases: [],
      page: 1,
      pageCount: 0,
      search: null,
      sortSelected: null
    };
  },
  mounted() {
    if (this._sortSelected && Object.keys(this._sortSelected).length > 0) {
      this.sortSelected = this._sortSelected;
    }
    if (this._search) {
      this.search = this._search;
    }
    if (this._page) {
      this.page = this._page;
    }
    this.getMySales();
  },
  methods: {
    getMySales() {
      let params = {
        page: this.page
      };
      if (this.sortSelected) {
        console.log("asd");
        switch (this.sortSelected.value) {
          case 1:
            params.sort = "off_quantity";
            params.sort_direction = "desc";
            break;
          case 2:
            params.sort = "off_quantity";
            params.sort_direction = "asc";
            break;
          case 3:
            params.sort = "pro_post_date";
            params.sort_direction = "desc";
            break;
          case 4:
            params.sort = "pro_post_date";
            params.sort_direction = "asc";
            break;
          case 5:
            params.sort = "pro_name";
            params.sort_direction = "desc";
            break;
          case 6:
            params.sort = "pro_name";
            params.sort_direction = "asc";
            break;
          default:
            params.sort = null;
            params.sort_direction = "desc";
        }
      }
      if (this.search && this.search !== "") {
        params.search = this.search;
      }
      // console.log(params)
      api
        .getMySales(params)
        .then(res => {
          for (var i = 0; i < res.data.data.length; i++) {
            res.data.data[i].open = false;
          }
          this.purchases = res.data.data;
          this.pageCount = res.data.page_count;
        })
        .catch(e => {
          console.log(e);
        });
    },
    edit(product, e) {
      e.stopPropagation();
      console.log("redirect", product.pro_id);
      let params = Object.assign({}, this.$route.params);
      params.id = product.pro_id;
      this.$router.push({ name: "EditAd", params: params });
    },
    navigateToAd(id, e) {
      e.stopPropagation();
      this.$router.push({
        name: "Details",
        params: { lang: this.$i18n.locale, id: id }
      });
    },
    openOffersList(purchase) {
      let params = {
        modalData: purchase,
        component: "productBuyers"
      };
      eventBus.$emit("openModal", params);
    },
    navigateToNewAd() {
      this.$router.push({ name: "NewAd", params: { lang: this.$i18n.locale } });
    },
    getPaginationImages(side) {
      let path = require(`@/assets/icons/pagination${side}.png`);
      return `<img src='${path}' alt='pagination left image'>`;
    },
    changePage(page) {
      this.page = page;
      this.purchases = [];
      this.getMySales();
    },
    renew(data, e) {
      e.stopPropagation();
      let modalData = {
        title: this.$t("main.renew"),
        id: data.pro_id,
        cancel: () => {
          this.getMySales();
        }
      };
      let params = {
        modalData: modalData,
        component: "renewModal"
      };
      eventBus.$emit("openModal", params);
    },
    archive(data, e) {
      e.stopPropagation();
      let modalData = {
        title: this.$t("modal.archiveProduct"),
        ok: () => {
          this.archiveProduct(data);
        }
      };
      let params = {
        modalData: modalData,
        component: "confirmModal"
      };
      eventBus.$emit("openModal", params);
    },
    archiveProduct(data) {
      let params = {
        pro_id: data.pro_id
      };
      api
        .deleteProductFromArchive(params)
        .then(res => {
          this.getMySales();
        })
        .catch(e => {
          console.log(e);
        });
    },
    openDeleteConfirmation(product, e) {
      e.stopPropagation();
      let modalData = {
        title: this.$t("modal.deleteProductTitle") + product.pro_name,
        ok: () => {
          this.deleteProduct(product);
        }
      };
      let params = {
        modalData: modalData,
        component: "confirmModal"
      };
      eventBus.$emit("openModal", params);
    },
    deleteProduct(product) {
      let params = {
        id: product.pro_id
      };
      eventBus.$emit("showLoader", true);
      api
        .deleteProduct(params)
        .then(res => {
          this.$toast.success(this.$t("main.deleteProductSuccess"), {
            duration: 8000
          });
          this.getMySales();
        })
        .catch(e => {
          console.log(e);
          this.$toast.error(this.$t("main.deleteProductError"), {
            duration: 8000
          });
        })
        .finally(() => {
          eventBus.$emit("showLoader", false);
        });
    }
  },
  computed: {
    sortList() {
      return [
        {
          label: this.$t("profile.sales.sort.1"),
          value: 1
        },
        {
          label: this.$t("profile.sales.sort.2"),
          value: 2
        },
        {
          label: this.$t("profile.sales.sort.3"),
          value: 3
        },
        {
          label: this.$t("profile.sales.sort.4"),
          value: 4
        },
        {
          label: this.$t("profile.sales.sort.5"),
          value: 5
        },
        {
          label: this.$t("profile.sales.sort.6"),
          value: 6
        }
      ];
    }
  },
  watch: {
    sortSelected: {
      handler() {
        this.$emit("changeSort", this.sortSelected);
      }
    },
    search: {
      handler() {
        this.$emit("changeSearch", this.search);
      }
    },
    page: {
      handler() {
        this.$emit("changePage", this.page);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
@import "@/assets/scss/tableStyles.scss";
.profile-my-sales-mobile-wrapper {
  .empty {
    text-align: left;
  }
  table {
    border: none;
    /* background: rgba(196, 196, 196, .15); */

    .underline {
      text-decoration: underline !important;
    }
  }
  .dropdown-row {
    /* background: rgba(196, 196, 196, .15); */
    border-bottom: 1px solid #e8e8e8;
    td {
      height: auto;
      padding: 5px;
      height: 100%;
      margin: 0 5px;
      overflow: hidden;
      transition-duration: 0.3s;

      .dropdown {
        transition-duration: 0.3s;
        background: white;
      }
    }
  }
  .bold-td-text {
    font-weight: 700;
  }
  .regular-td-text {
    font-weight: 500;
  }
  .light-grey {
    position: relative;
    color: #9b9b9b;
    text-align: right;
    vertical-align: top;
    font-weight: 400;
    .date-span {
      margin: 15px 5px;
      height: 50px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
    }
    span {
      margin: 0px 5px;
    }
    .icon-wrapper {
      position: absolute;
      right: 10px;
      top: 7px;
      margin: 0 0 10px 0;
    }
  }
  .status-color {
    color: #8e3e4c;
    text-align: right;
    font-weight: 600;
  }
  .dropdown-row.active {
    cursor: default;
    td {
      border-bottom: none;
      height: auto;
      padding: 10px;
      height: 100%;
      overflow: hidden;
      transition-duration: 0.3s;

      &.dropdown-td {
        padding: 0;
        // border-radius: 15px;
      }

      .dropdown {
        border: 1px solid $blue-600;
        border-radius: 15px;
        height: auto;
        transition-duration: 0.3s;
        box-sizing: border-box;
        // box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
        padding: 10px;

        .dropdown-header {
          display: flex;
          flex-direction: column;
          align-items: center;

          .header {
            font-weight: bold;
            font-size: 17px;
            line-height: 28px;
            letter-spacing: 0.06em;
            text-transform: uppercase;
          }
          div {
            margin-bottom: 15px;
          }
        }
      }
    }
  }
  tr.deleted td {
    background: rgba(196, 196, 196, 0.15);
  }
  tr td:last-child {
    font-size: 0.9em;
  }
  tbody tr td {
    border-bottom: none;
    vertical-align: top;
    padding: 5px;
  }
  tbody tr {
    cursor: pointer;
  }
  .actions-wrapper {
    margin-bottom: 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .btn-dropdown-wrapper {
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px;
    }

    input {
      border: none;
      border-bottom: 1px solid #ddd;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      height: 20px;
      line-height: 20px;
      padding: 9px;
      font-weight: bold;
      font-size: 13px;
      line-height: 15px;
      letter-spacing: 0.02em;
      color: $text-color;
      width: 100%;
      margin: 15px 0 30px;
    }
    input:focus {
      outline: none;
    }
    .btn {
      width: 170px;
    }
  }
  .search-wrapper {
    width: 100%;
    margin-bottom: 10px;
    input {
      width: 70%;
    }
  }
  /*@media only screen and (max-width: 768px){
    .actions-wrapper {
      flex-direction: column;
      .btn {
        margin-bottom: 40px;
      }
    }
  }*/
  // vidite da li je bolje ovako kada su manji ekrani
  /*
  @media only screen and (max-width: 550px){
    tr {
      display: flex;
      flex-direction: column;
    }
    tr td{
      text-align: center!important;
    }
  }*/
}
</style>
